export class Keyboard {
    static dismiss = () => {
        return null
    }
}